"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var saveToDisk_1 = require("../../../common/helpers/saveToDisk");
var InstructorStudentFilesController = /** @class */ (function () {
    function InstructorStudentFilesController($stateParams, UsersModel, FlashService, FilesModel, $q) {
        var _this = this;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.FilesModel = FilesModel;
        this.$q = $q;
        this.files = [];
        this.fileType = "";
        this.submitting = false;
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.selectFileType = this.selectFileType.bind(this);
        UsersModel.getFiles(this.$stateParams.student_id).then(function (response) {
            _this.files = response.files;
        });
    }
    InstructorStudentFilesController.prototype.selectFileType = function (fileType) {
        this.fileType = fileType;
    };
    InstructorStudentFilesController.prototype.handleFileUpload = function (formData) {
        var _this = this;
        this.submitting = true;
        var promises = [];
        formData.entries().forEach(function (entry) {
            var fd = new FormData();
            var file = entry[1];
            fd.append("file", file, file.name);
            fd.append("students", JSON.stringify([_this.$stateParams.student_id]));
            promises.push(_this.FilesModel.uploadFile(_this.fileType, file.name, fd));
        });
        this.$q
            .all(promises)
            .then(function (responses) {
            responses.forEach(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.files.push(response.file);
            });
            _this.submitting = false;
            _this.fileType = "";
        })
            .catch(function (error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong uploading the file.",
            });
            _this.submitting = false;
            _this.fileType = "";
        });
    };
    InstructorStudentFilesController.prototype.formatDate = function (datestring) {
        return new Date(datestring).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };
    InstructorStudentFilesController.prototype.deleteFile = function (id) {
        var _this = this;
        this.FilesModel.destroy(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.files = _this.files.filter(function (file) {
                return file.id !== id;
            });
        })
            .catch(function (error) { });
    };
    InstructorStudentFilesController.prototype.downloadFile = function (id) {
        var _this = this;
        this.FilesModel.get(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            (0, saveToDisk_1.saveToDisk)(response.temporary_url);
        })
            .catch(function (error) { });
    };
    return InstructorStudentFilesController;
}());
InstructorStudentFilesController.$inject = [
    "$stateParams",
    "UsersModel",
    "FlashService",
    "FilesModel",
    "$q",
];
exports.default = InstructorStudentFilesController;
